import { render, staticRenderFns } from "./ImageFile.vue?vue&type=template&id=7c31b726&"
import script from "./ImageFile.vue?vue&type=script&lang=js&"
export * from "./ImageFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports